import { render, staticRenderFns } from "./SummaryTarpStatus.vue?vue&type=template&id=4cb72290&scoped=true&"
import script from "./SummaryTarpStatus.vue?vue&type=script&lang=ts&"
export * from "./SummaryTarpStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryTarpStatus.vue?vue&type=style&index=0&id=4cb72290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb72290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VContainer,VIcon,VSpeedDial})
